// src/features/policies/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import SearchPolicy from './pages/searchPolicy/SearchPolicy';
import PolicyForm from './pages/searchPolicy/PolicyForm';
import Detail from './pages/searchPolicy/Detail';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const policiesRoute = createRoute({
  getParentRoute: () => rootRoute,
    path: '/policies',
});

export const policiesPolicyHolderRoute = createRoute({
  getParentRoute: () => policiesRoute,
    path: '/search-policy',
    component: SearchPolicy,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.POLICIES.SEARCH_POLICY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const policiesCreateFormRoute = createRoute({
    getParentRoute: () => policiesRoute,
    path: '/search-policy/form',
    component: PolicyForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.POLICIES.SAVE_POLICY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const policiesCreateOnlyFormRoute = createRoute({
    getParentRoute: () => policiesRoute,
    path: '/create-policy',
    component: PolicyForm    
});

export const searchPolicyDetailRoute = createRoute({
    getParentRoute: () => policiesRoute,
    path: '/search-policy/detail',
    component: Detail,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.POLICIES.GET_POLICY_DETAIL || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const policiesRoutes = [
  policiesRoute,
    policiesPolicyHolderRoute,
    policiesCreateFormRoute,
    policiesCreateOnlyFormRoute,
    searchPolicyDetailRoute
];